import type { RouteObject } from "react-router-dom";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PostPage from "../pages/post/page";

function PostPageWrapper() {
  const { slug } = useParams<{ slug: string }>();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);
  return <PostPage key={slug} />;
}
import CategoryPage from "../pages/category/page";
import TagPage from "../pages/tag/page";
import AboutPage from "../pages/about/page";
import PrivacyPage from "../pages/privacy/page";
import ContactPage from "../pages/contact/page";
import SearchPage from "../pages/search/page";
import ArchivePage from "../pages/archive/page";
import TermsPage from "../pages/terms/page";
import DisclaimerPage from "../pages/disclaimer/page";
import AdvertisePage from "../pages/advertise/page";
import TrafficDashboard from "../pages/admin/traffic/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/post/:slug", element: <PostPageWrapper /> },
  { path: "/category/:slug", element: <CategoryPage /> },
  { path: "/tag/:tag", element: <TagPage /> },
  { path: "/search", element: <SearchPage /> },
  { path: "/archive", element: <ArchivePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/privacy-policy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/disclaimer", element: <DisclaimerPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/advertise", element: <AdvertisePage /> },
  { path: "/admin/traffic", element: <TrafficDashboard /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
